import { Injectable, inject } from '@angular/core';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root',
})
export class UtilitiesService {
  private readonly environmentService = inject(EnvironmentService);

  isDevelopmentMode(): boolean {
    return !this.environmentService.isProduction || window.location.href.includes('disable_mixpanel=true');
  }

  getPlatform(): 'Mobile' | 'Web' {
    const ua = navigator.userAgent;
    const isMobile = /android/i.test(ua) || /iPad|iPhone|iPod/.test(ua);
    return isMobile ? 'Mobile' : 'Web';
  }

  toLocaleCapitalize(text: string, locale: string = 'default'): string {
    if (!text) return text;
    return text.charAt(0).toLocaleUpperCase(locale) + text.slice(1).toLocaleLowerCase(locale);
  }
}
